import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";

import { BrowserTitleService } from "../../../common/browser-title/browser-title.service";
import { ForgotPasswordState } from "./models";

@Component({
	templateUrl: "./forgot-password.component.html"
})
export class ForgotPasswordComponent implements OnInit {
	public isPasswordLoading = false;

	public email = "";
	public state = ForgotPasswordState.Initial;

	constructor(
		private titleService: BrowserTitleService,
		private route: ActivatedRoute
	) { }

	public ngOnInit() {
		this.titleService.setTitle("forgotpassword.title");

		this.route.queryParams.subscribe((params: Params) => {
			if (params["code"]) {
				this.state = ForgotPasswordState.Change;
			}
		});
	}

	public get isStateInitial() {
		return this.state === ForgotPasswordState.Initial;
	}

	public get isStateEmailPending() {
		return this.state === ForgotPasswordState.EmailPending;
	}

	public get isStateChange() {
		return this.state === ForgotPasswordState.Change;
	}

	public showLoadingBar() {
		this.isPasswordLoading = true;
	}

	public hideLoadingBar() {
		this.isPasswordLoading = false;
	}

	public showPendingEmail(email: string) {
		this.email = email;
		this.state = ForgotPasswordState.EmailPending;
	}
}
